import http from '../utils/http'

const getAll = (query) => {
  const params = new URLSearchParams()
  const page = query.hasOwnProperty('page') ? query.page : 1
  const size = query.hasOwnProperty('size') ? query.size : 100
  params.append('PageNumber', page)
  params.append('PageSize', size)

  if (query.hasOwnProperty('address') && query.address) {
    params.append('JobNoOrAddress', query.address)
  }

  if (query.hasOwnProperty('clientId') && query.clientId) {
    params.append('ClientId', query.clientId)
  }

  return http.get(`/Job`, { params })
}

const getById = (id) => http.get(`/Job/${id}`)

const getFiles = (id) => http.get(`/Job/${id}/files`)

const getZipWithAllFiles = (id) => http.get(`/Job/${id}/files/download`, { responseType: 'blob' })

const getInstructions = (id) => http.get(`/Job/${id}/instructions`)

const getCommunications = (id) => http.get(`/Job/${id}/communications`)

const getPhotos = (id) => http.get(`/Job/${id}/photos`)

const getZipWithAllPhotos = (id) => http.get(`/Job/${id}/photos/download`, { responseType: 'blob' })

const getNotes = (id) => http.get(`/Job/${id}/notes`)

const getSors = (id) => http.get(`/Job/${id}/sors`)

export default {
  getAll,
  getById,
  getFiles,
  getZipWithAllFiles,
  getInstructions,
  getCommunications,
  getPhotos,
  getZipWithAllPhotos,
  getNotes,
  getSors
}
